import React from "react";

interface IProps {
    text?: string;
    className?: string;
}
interface IState {
    title: string;
}

class BaseTruncatedText extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            title: "",
        } as IState;
    }

    private hasUnmounted = false;
    private textRef: React.RefObject<HTMLDivElement> = React.createRef<HTMLDivElement>();

    public componentDidMount() {
        if (this.props.text) {
            this.setTitleIfTruncated();
            window.addEventListener("resize", this.setTitleIfTruncated);
            window.addEventListener("orientationchange", this.setTitleIfTruncated);
        }
    }

    public componentDidUpdate(prevProps: Readonly<IProps>) {
        if (prevProps.text?.length !== this.props.text?.length) {
            this.setTitleIfTruncated();
        }
    }

    public componentWillUnmount() {
        this.hasUnmounted = true;
        window.removeEventListener("resize", this.setTitleIfTruncated);
        window.removeEventListener("orientationchange", this.setTitleIfTruncated);
    }

    private setTitleIfTruncated = () => {
        let title = "";
        if (this.textRef.current && this.textRef.current.scrollWidth > this.textRef.current.clientWidth) {
            title = this.textRef.current.innerText ?? "";
        }
        if (this.hasUnmounted === false) {
            this.setState({
                title: title,
            });
        }
    };

    public render(): JSX.Element {
        const { text, className } = this.props;
        const { title } = this.state;

        return (
            <div ref={this.textRef} className={[className].join(" ")} title={title || undefined}>
                {text}
            </div>
        );
    }
}

export { BaseTruncatedText as Unconnected };
export default BaseTruncatedText;
